module.exports = __webpack_public_path__ + "img/luolai.8f73d774.png";